import { useState } from 'react'
import './App.css'
import Header from './components/Header.jsx'
import Hero from './components/Hero.jsx'
import About from './components/About.jsx'
import Products from './components/Products.jsx'
import Services from './components/Services.jsx'
import Footer from './components/Footer.jsx'
import Testimonials from './components/Testimonials.jsx'
import Blogs from './components/Blogs.jsx'
import Contact from './components/Contact.jsx'
import Industries from './components/Industries.jsx'
import Insights from './components/Insights.jsx'
import GlobalReach from './components/GlobalReach.jsx'
import SmoothCursor from './components/SmoothCursor.jsx'

function App() {

  return (
    <>
      <SmoothCursor />
      <Header />
      <Hero />
      <Services />
      <Industries />
      <Products />
      {/* <Insights /> */}
      <GlobalReach />
      <Blogs />
      <About />
      <Testimonials />
      <Contact />
      <Footer />
    </>
  )
}



export default App
